<template>
  <div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Type:</span>
      <span class="text-sm">{{ basicInfo['Device Type'] || basicInfo.device_type || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">IP Address:</span>
      <span class="text-sm">{{ basicInfo['IP Address'] || basicInfo.ip_address || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">MAC Address:</span>
      <span class="text-sm">{{ basicInfo['MAC Address'] || basicInfo.mac_address || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Serial Number:</span>
      <span class="text-sm">{{ basicInfo['Serial No.'] || basicInfo['Serial No'] || basicInfo.serial_no || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Firmware Version:</span>
      <span class="text-sm">{{ basicInfo['Firmware Version'] || basicInfo.firmware_version || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">BIOS Version:</span>
      <span class="text-sm">{{ basicInfo['BIOS Version'] || basicInfo.bios_version || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">CPU Usage:</span>
      <span class="text-sm">{{ basicInfo['CPU Usage'] || basicInfo.cpu_usage || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Memory Usage:</span>
      <span class="text-sm">{{ basicInfo['Memory Usage'] || basicInfo.memory_usage || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Current Time:</span>
      <span class="text-sm">{{ basicInfo['Current Time'] || basicInfo.current_time || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Uptime:</span>
      <span class="text-sm">{{ basicInfo.Uptime || basicInfo.uptime || 'N/A' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitchBasicInfo',
  props: {
    basicInfo: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
}
</script>

